import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './OtherIdentityInfo.module.css'
import {
  Col,
  Flex,
  Input,
  Row,
  Select
} from 'antd'
import classNames from 'classnames'
import { ReactComponent as DeleteIcon } from './delete.svg'
// import deleteIcon1 from './delete1.svg'
export default function OtherIdentityInfo(props) {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [identityTypeList, setIdentityTypeList] = useState([
    {
      label: '学科老师',
      value: '1',
    },
    {
      label: '班主任',
      value: '2',
    },
    {
      label: '其他',
      value: '3',
    },
  ])

  // const incrementValue = Number(incrementAmount) || 0;
  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    console.log('---------->>aslkdfj')
    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  return (
    <Flex vertical={false} gap={16} style={{ marginTop: 16 }}>
      <Select
        placeholder="请选择在校身份信息"
        size="large"
        style={{ backgroundColor: 'white', minWidth: 120,width:120 }}
        options={identityTypeList}
        value={props.info.type}
        onChange={(index, typeInfo) => {
          props.handleIdentityTypeChange(props.index, typeInfo)
        }}
      />
      <Input
        placeholder="请输入职务（如：教务主任）"
        size="large"
        style={{ backgroundColor: 'white' }}
        value={props.info.qita_content}
        onChange={(e) => {
          props.handleQitaContentChange(props.index, e.target.value)
        }}
      />
      <DeleteIcon className={styles.deleteIcon} onClick={() => {
        props.handleDelete(props.index)
      }} />
    </Flex>
  )
}
